<!-- PrintMemberPage.vue -->
<template>
  <div class="print-page">
    <PrintMember :value="printData" :board="boardData" />
  </div>
</template>

<script>
import PrintMember from './PrintMember.vue'

export default {
  name: 'PrintMemberPage',
  components: {
    PrintMember
  },
  data() {
    return {
      printData: [],
      boardData: {}
    }
  },
  mounted() {
    try {
      // URL 파라미터에서 스토리지 키 가져오기
      const params = new URLSearchParams(window.location.search);
      const storageKey = params.get('storageKey');

      if (!storageKey) {
        throw new Error('데이터 키를 찾을 수 없습니다.');
      }

      // localStorage에서 데이터 가져오기
      const rawData = localStorage.getItem(storageKey);
      const rawBoardData = localStorage.getItem(`${storageKey}_board`);

      if (!rawData) {
        throw new Error('프린트 데이터를 찾을 수 없습니다.');
      }

      // 데이터 파싱
      this.printData = JSON.parse(rawData);
      this.boardData = rawBoardData ? JSON.parse(rawBoardData) : {};

      // 데이터 로드 후 자동 출력
      this.$nextTick(() => {
        window.print();
      });

      // 사용한 데이터 정리
      localStorage.removeItem(storageKey);
      localStorage.removeItem(`${storageKey}_board`);
    } catch (error) {
      console.error('데이터 로드 에러:', error);
    }
  }
}
</script>

<style scoped>
.print-page {
  padding: 20px;
}

/*@media print {
  @page {
    size: A4;
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }

  .print-page {
    padding: 0;
  }
}*/
</style>
